// web/src/tutorial-quickstart.ts
// /quickstart/<slug>.html 的入口脚本。
// 只 import Quick Start 这一类正文：四类正文合起来近 2MB，
// 入口按类分包才能让本页只下载自己这一类的图文。
import { initTutorialPage } from "./tutorial/pages";
import { QUICKSTART_DOCS } from "./tutorial/quickstart/index";

initTutorialPage("quickstart", QUICKSTART_DOCS);
